/**
 * Maps permission docs by their source claim id (approved claims).
 * @param {Array<Record<string, unknown>>} permissionRows
 * @returns {Map<string, Record<string, unknown>>}
 */
export function mapPermissionsBySourceClaimId(permissionRows) {
  const list = Array.isArray(permissionRows) ? permissionRows : [];
  const byClaimId = new Map();
  for (const row of list) {
    const sourceClaimId =
      typeof row.sourceClaimId === 'string' ? row.sourceClaimId.trim() : '';
    if (sourceClaimId.length > 0) {
      byClaimId.set(sourceClaimId, row);
    }
  }
  return byClaimId;
}
